import React, { createContext, useContext, useEffect, useState } from "react";
import { checkAccessBulk } from "../Rest_api/RestApi";
import { getLoggedIn } from "../pages/Protected";

interface AccessContextType {
  accessMap: Record<string, boolean>;
  loading: boolean;
}

const AccessContext = createContext<AccessContextType>({
  accessMap: {},
  loading: true,
});

export function AccessProvider({ children }: { children: React.ReactNode }) {
  const [accessMap, setAccessMap] = useState<Record<string, boolean>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!getLoggedIn()) {
      setLoading(false);
      return;
    }
    checkAccessBulk()
      .then((res) => {
        if (res.status === true && res.permissions) {
          const map: Record<string, boolean> = {};
          for (const key of res.permissions) {
            map[key] = true;
            map[key.toLowerCase()] = true;
          }
          setAccessMap(map);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <AccessContext.Provider value={{ accessMap, loading }}>
      {children}
    </AccessContext.Provider>
  );
}

export function useAccess() {
  return useContext(AccessContext);
}
